import { render, staticRenderFns } from "./ActionClassificationComponent.vue?vue&type=template&id=7bf279f0&scoped=true"
import script from "./ActionClassificationComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionClassificationComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ActionClassificationComponent.vue?vue&type=style&index=0&id=7bf279f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf279f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf279f0')) {
      api.createRecord('7bf279f0', component.options)
    } else {
      api.reload('7bf279f0', component.options)
    }
    module.hot.accept("./ActionClassificationComponent.vue?vue&type=template&id=7bf279f0&scoped=true", function () {
      api.rerender('7bf279f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/actions/ActionClassification/ActionClassificationComponent.vue"
export default component.exports